import { AxiosResponse } from 'axios';
import { ICalendar } from 'calendar/entities';
import { Dispatch } from 'redux';
import { AppThunk } from 'store';

import { CalendarApi } from '../api/calendar.api';
import {
  fetchUpdateCalendar,
  fetchUpdateCalendarFailed,
  fetchUpdateCalendarSucceeded,
} from '../slices/calendar.slice';

export const updateCalendar = (
  calendarId: string,
  partialCalendar?: Partial<ICalendar>,
  key?: string,
): AppThunk<Promise<ICalendar>> => async (dispatch: Dispatch) => {
  let response: AxiosResponse<ICalendar> = null;
  dispatch(fetchUpdateCalendar({ key }));

  try {
    response = await CalendarApi.update(calendarId, partialCalendar);
    dispatch(fetchUpdateCalendarSucceeded({ key, calendar: response.data }));

    return response.data;
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;

    const error = {
      isAxiosError,
      message: responseError?.data?.message,
      name,
      code: responseError?.data?.statusCode,
      stack,
      config: null,
      toJSON: null,
    };
    dispatch(fetchUpdateCalendarFailed({ key, error }));
    throw error;
  }
};
